module.exports = __webpack_public_path__ + "img/1523849802.aa298549.jpg";